import '../../App.css';
import './EditorLayout.scss';

interface EditorLayoutProps {
  children: React.ReactNode;
}

export default function EditorLayout({ children }: EditorLayoutProps) {
  return (
    <div className="main-layout">
      <div className="editor-wrapper">
        {children}
      </div>
    </div>
  );
}
